import React from "react";
import { Link } from "../../lib/Link";
import { area_selector } from "../../common/area_selector";
import areas from "../../common/areas";
import masterData from "../../lib/masterData";
import { TYPE_SP } from "../../common/defines";
import { SearchKeywordTop } from "./SearchKeywordTop";
import { getUrl } from "../../lib/masterUtil";

export const area_search = (type, history) => {
  const queryString = location.search ? "list/" + location.search : "";
  const areaSplit = [areas.slice(0, 3), areas.slice(3, 6)];
  const getPosition = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const url = getUrl({ condition: { "keyword": "geo_" + position.coords.latitude + "_" + position.coords.longitude } });
        history.push(url);
      },
      (error) => {
        // alert("現在位置が取得できませんでした");
      }
    );
  };

  return (
    <div className="searchbox">
    <SearchKeywordTop/>
    {type === TYPE_SP && <div className="geo">
      <button className="btn center black" onClick={getPosition}>
        <div><img src="resource/img/mappin.png"/><span>　現在地から検索</span></div>
      </button>
    </div>}
    <div className="container"><div className="areatitle"><img src="resource/img/title_area_sp.png" className="title pchide" /></div></div>
      <div className="area_search">
        <div className="container">
          <div className="title">
            <img src="resource/img/title_searcharea.png" />
          </div>
          {areaSplit.map((areaPart, index) => (
            <ul key={index}>
              {areaPart.map((area, areaIndex) => (
                <li key={areaIndex}>
                  <div className="tits">{area.title}</div>
                  {area.children.map((pref, prefIndex) => (
                    <Link to={`/${pref}/${queryString}`} key={prefIndex}>
                      {masterData.pref.bySlug[pref].shortName}
                    </Link>
                  ))}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      {type === TYPE_SP && <div>
        {area_selector(type)}
      </div>}

      <div className="about">
        <img src="resource/img/about_pc.png" />
        <div className="content">
          <div>ハローストレージは、「家庭用」「企業用」のトランクルームとして誕生し、現在は全国に1,981物件・97,011室展開中！</div>
          <div>室内を大小のスペースで区画し、お客様のご利用用途に適したサービスをご利用いただけるよう、様々なサイズ・商品タイプをご用意しております。</div>
        </div>
        <Link to={"/lineup/contena"} className="boxItem"><span>屋外型トランクルーム</span></Link>
        <Link to={"/lineup/trunk"} className="boxItem"><span>屋内型トランクルーム</span></Link>
        <Link to={"/lineup/premium"} className="boxItem"><span>トランクハウス24シリーズ</span></Link>
        <Link to={"/lineup/bike"} className="boxItem"><span>バイク専用トランクルーム</span></Link>
      </div>
    </div>

  );
};



// WEBPACK FOOTER //
// ./pages/top/area_search.jsx